export default __webpack_public_path__ + "static/stellar-73519cfe37bb4564e918933952137a71.png";